/** Thrown by `LabelFormatter.parse*` and `GridSystem.parseCoordinate` when input is unparseable. */
export class ParseError extends Error {
    text;
    reason;
    constructor(text, reason) {
        super(`ParseError: ${reason} (input: ${JSON.stringify(text)})`);
        this.name = 'ParseError';
        this.text = text;
        this.reason = reason;
    }
}
//# sourceMappingURL=ParseError.js.map